// import Axios from '@/lib/api.request'
import Axios from "axios";
import { LOGIN_GRANT_TYPE, AUTHORIZATION } from "@/config/application";
import Storage from "@/utils/storage";
import { vm } from "@/main";
import { LOGIN_PATH, LOGIN_CLIENT_ID } from "@/config/env";
import Store from "./../store/index";
Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    let message;
    let description;
    let response = error.response;
    if (response) {
      message = response.data.error;
      description = response.data.error_description;
    } else {
      message = "";
      description = error.message;
    }
    // 将接口报错的提示注释
    // vm.$notification['error']({
    //   message,
    //   description,
    // });
    return Promise.reject(error);
  }
);
// 获取token
export const getToken = ({ code, redirect_uri }) => {
  return Axios.request({
    method: "POST",
    url: "/auth/oauth/token",
    params: {
      // client_id: LOGIN_CLIENT_ID,
      // client_secret: LOGIN_CLIENT_SECRET,
      grant_type: LOGIN_GRANT_TYPE,
      code: code,
      redirect_uri: redirect_uri,
    },
    headers: {
      Authorization: `Basic ${AUTHORIZATION}`,
      "Content-Type": "application/x-www-form-urlencoded;",
    },
  });
};
export const getUserInfo = () => {
  const token = Storage("token").token;
  return Axios.request({
    method: "POST",
    url: "/auth/user/principal",
    params: {
      bearer: token,
    },
    headers: {
      Authorization: `bearer ${token}`,
      "Content-Type": "application/x-www-form-urlencoded;",
    },
  });
};

// 获取用户菜单
export const getUserMenus = (userId) => {
  return Axios.post(
    "/idaasApi/authApi/menu/tree",
    {
      userId: userId,
      clientId: LOGIN_CLIENT_ID,
    },
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${Storage("token").token}`,
      },
    }
  );
};

// 获取应用标题和自定义图标
export const getApplicationInfo = () => {
  return Axios.post(
    "/auth/tenant/detail",
    {},
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `bearer ${Storage("token").token}`,
        "X-AUTH-USER": window.btoa(Store.getters.userInfo.userId),
        "X-AUTH-TENANT": window.btoa(Store.getters.userInfo.tenantId),
      },
    }
  );
};

// 个人中心
export const toPersonalHub = () => {
  window.open(`${LOGIN_PATH}/userMessage`);
};
export const toUpdatePwd = () => {
  window.open(`${LOGIN_PATH}/updatePassword`);
};

export const logout = () => {
  window.location.href = `${LOGIN_PATH}/logout`;
};

// 切换登录模式后获取token
export const switchLoginModeGetToken = (key, clientId) => {
  return Axios.post(
    "/auth/gt/getAppToken",
    {
      key,
      clientId,
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );
};

// 获取跳转链接
export const getOtherSystemLink = () => {
  return Axios.request({
    method: "get",
    url: "/auth/application-sdk",
    headers: {
      Authorization: `Bearer ${Storage("token").token}`,
      "X-AUTH-USER": window.btoa(Store.getters.userInfo.userId),
      "X-AUTH-TENANT": window.btoa(Store.getters.userInfo.tenantId),
    },
  });
};

// 从后台去校验token是否有效
export const checkCurrentToken = () => {
  return Axios.request({
    method: "POST",
    url: "/auth/oauth/check_token",
    params: {
      token: localStorage.getItem("token"),
    },
  });
};
